import React, { useState } from 'react'

import { ClockIcon, CalendarIcon, FastForwardIcon, ReceiptTaxIcon } from '@heroicons/react/solid'
import { formatInTimezone } from '@/utils/date'
import { useGlobalState } from '@/state'
import useQuery from '@/hooks/useQuery'
import PrimaryButton from '@/shared/Buttons/Primary'
import DefaultButton from '@/shared/Buttons/Default'

const CohortRow = ({cohort, cohortInterest, updateCost, alreadyEnrolled, alreadyTaken, following}) => {
  const { putpostRequest } = useQuery()
  const [, setToast] = useGlobalState('toast')
  const [currentUser] = useGlobalState('currentUser')
  const isFreeMember = ['lead', 'beta'].includes(currentUser.access)
  const hideSelectToggle = alreadyEnrolled || alreadyTaken

  const [ selected, setSelected ] = useState(cohortInterest?.includes(cohort.id))
  const [ followed, setFollowed ] = useState(following?.includes(cohort.courseId))
  const [ loading, setLoading ] = useState(false)
  const soldOut = cohort.seatsRemaining <= 0

  const toggleFollow = () => {
    setLoading(true)
    putpostRequest(`/api/v1/courses/${cohort.courseId}/follow`, 'POST', {}, (err, jsonData) => {
      if (err) { console.log('toast errors'); return }

      setLoading(false)
      const newValue = !followed
      setFollowed(newValue)
    })
  }
  return <>
    <div className='bg-white dark:bg-gray-800 flex flex-col sm:flex-row items-center sm:px-6 rounded-lg shadow-lg flex-wrap :flex-nowrap'>
      <div className="min-w-0 flex-1 flex items-center  flex-wrap sm:flex-nowrap">
        <div className="flex-shrink-0 hidden sm:block">
          <img className="sm:h-12 sm:w-20 rounded-lg" src={cohort.imageUrl} alt="" />
        </div>
        <div className="min-w-0 flex-auto md:grid md:grid-cols-2 md:gap-4">
          <div className="flex-shrink-0 sm:hidden">
            <img className="w-full rounded-lg" src={cohort.imageUrl} alt="" />
          </div>
          <div className='px-4'>
            <span className="uppercase text-xs dark:text-gray-500 text-gray-500 mr-5">{cohort.topic}</span>
            <p className="font-medium text-clcpurple truncate">{cohort.name}</p>
            <a href={`/courses/${cohort.courseSlug}`} className='mt-4 text-sm'>Full Course Details</a>
          </div>
          <div className="px-4 text-gray-500 dark:text-gray-300 text-sm">
            <span className='text-gray-500 dark:text-gray-300 text-sm flex mt-1'><FastForwardIcon className='w-5 h-5 mr-2' />{cohort.weeks} weeks / {cohort.sessionDuration} minutes each week</span>
            <span className='text-gray-500 dark:text-gray-300 text-sm flex mt-1'><ReceiptTaxIcon className='w-5 h-5 mr-2' />{cohort.creditCost} credits</span>
          </div>
        </div>
      </div>
      { !followed && <PrimaryButton className='my-4' onClick={toggleFollow} text='Remind Me' /> }
      { followed && <DefaultButton className='my-4' onClick={toggleFollow} text={<span className='text-green-500'>Reminder Set!</span>} /> }
    </div>
  </>
}

export default CohortRow
